import type { EventCallbackFunction } from '@azure/msal-browser';
import { tryOnUnmounted } from '@vueuse/core';
import { useMsalStore } from '../stores/msal-store';

export function onMsalMessage(callback: EventCallbackFunction): {
    off: () => void;
} {
    const msalStore = useMsalStore();

    msalStore.addEventCallback(callback);

    const off = () => {
        msalStore.removeEventCallback(callback);
    };

    tryOnUnmounted(off);

    return { off };
}
